import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Translation from '../../i18n/Translation';
import { getAmount } from '../selectors';
import WhatNextBanner from '../WhatNextBanner';

export const Success = ({ amount }) => (
  <div className="withdraw-result">
    <h1 className="withdraw-result__status withdraw-result__status--success">
      <div className="withdraw-result__status-icon">
        <i className="withdraw-result__status-circle">
          <i className="material-icon material-icon--check" />
        </i>
      </div>
      <Translation section="withdraw" label="successTitle" />
    </h1>
    {
      amount && (
        <p className="withdraw-result__amount">
          <Translation section="withdraw" label="successAmount" variables={{ amount }} />
        </p>
      )
    }
    <WhatNextBanner />
  </div>
);

Success.propTypes = {
  amount: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

const mapStateToProps = (state) => ({
  amount: getAmount(state)
});

export default connect(mapStateToProps)(Success);
